module.exports = __webpack_public_path__ + "static/kwekkwekfinal-4efe82a747b291052d29e2885b5eac5e.jpg";